import React from 'react'
import { useDispatch } from 'hooks/use-redux'
import { useNavigate, useParams } from 'react-router-dom'
import ModalDialog from 'components/ui/modal-dialog'

const DeferredContactImportSuccessDialog = (): React.ReactNode => {
  const params = useParams<{ listId?: string }>()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { listId } = params

  const onClose = () => {
    navigate(listId ? `/lists/${listId}` : '/contacts/list')
  }

  return (
    <ModalDialog
      title="Success!"
      primaryAction={{
        caption: 'Close',
        onClick: onClose,
      }}
      notClosable
    >
      Your contacts are being imported. We’ll let you know by email when the
      import is complete.
    </ModalDialog>
  )
}

export default DeferredContactImportSuccessDialog
